import styled, { css, keyframes } from 'styled-components';
import { MediaQuery, Palette } from 'core/config';

export const LIME_GREEN = '#DEF59D';
export const ACCENT_GREEN = '#DEF59D';
export const SPEER_LIME = '#DEF59D';
export const SPEER_BLACK = 'rgb(5, 5, 5)';
export const STARTER_BG = 'rgb(248, 248, 244)';
export const STARTER_BORDER = 'rgb(220, 220, 216)';
export const LIVE_BG = 'rgb(245, 244, 240)';
export const LIVE_BORDER = 'rgb(210, 210, 204)';

export const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
`;

export const gradientShift = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`;

export const PageContainer = styled.div`
    background: ${Palette.WHITE};
    color: ${Palette.BLACK};
    min-height: 100vh;
`;

export const SectionInner = styled.div`
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 0 24px;

    @media ${MediaQuery.tablet} {
        padding: 0 48px;
    }

    @media ${MediaQuery.laptopL} {
        padding: 0 64px;
    }
`;

export const SectionBlock = styled.section<{ $spacing?: 'medium' | 'large' }>`
    padding: ${({ $spacing }) => ($spacing === 'large' ? '96px' : '72px')} 0;

    @media ${MediaQuery.tablet} {
        padding: ${({ $spacing }) => ($spacing === 'large' ? '120px' : '96px')} 0;
    }
`;

export const pillButtonStyles = css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 14px 32px;
    border-radius: 999px;
    font-family: 'Poppins-Regular', sans-serif;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    transition: transform 0.25s ease, background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;
    white-space: nowrap;

    &:hover {
        transform: scale(1.03);
    }

    @media ${MediaQuery.tablet} {
        font-size: 15px;
        padding: 16px 36px;
    }
`;

export const PrimaryPillButton = styled.a`
    ${pillButtonStyles}
    background: ${Palette.BLACK};
    color: ${Palette.WHITE};
    border: 1px solid ${Palette.BLACK};

    &:hover {
        background: ${Palette.COD_GREY};
    }
`;

export const SecondaryPillButton = styled.a`
    ${pillButtonStyles}
    background: ${Palette.WHITE};
    color: ${Palette.BLACK};
    border: 1px solid ${Palette.BLACK};

    &:hover {
        background: ${Palette.WILD_SAND};
    }
`;

export const SectionHeading = styled.h2`
    font-family: 'Poppins-Medium', sans-serif;
    font-size: 28px;
    line-height: 1.2;
    margin: 0 0 20px;

    @media ${MediaQuery.tablet} {
        font-size: 36px;
    }
`;

export const BodyText = styled.p`
    font-family: 'Poppins-Light', sans-serif;
    font-size: 15px;
    line-height: 1.7;
    margin: 0;
    color: ${Palette.COD_GREY};

    @media ${MediaQuery.tablet} {
        font-size: 16px;
    }
`;

export const BulletList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const BulletItem = styled.li`
    font-family: 'Poppins-Light', sans-serif;
    font-size: 15px;
    line-height: 1.6;
    color: ${Palette.COD_GREY};
    padding-left: 20px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.65em;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: ${Palette.BLACK};
    }

    @media ${MediaQuery.tablet} {
        font-size: 16px;
    }
`;
